module.exports = __webpack_public_path__ + "img/humanImg2.7b4cacb2.png";